import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { client, urlFor } from '../client'; 

const Structure = () => {
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // 1. Ambil Data dari Sanity saat komponen dimuat
  useEffect(() => {
    const fetchContent = async () => {
      try {
        // Query data siswa
        const studentQuery = '*[_type == "student"] | order(nickName asc)';
        const studentRes = await client.fetch(studentQuery);
        
        // Memformat data
        const formattedStudents = studentRes.map((item, i) => ({
          id: item._id || i,
          name: item.nickName,
          fullName: item.fullName,
          
          // PERBAIKAN DI SINI:
          // Mengambil data 'role' dari Sanity. Jika kosong, default ke "Student"
          role: item.role || "Student", 
          
          img: item.photo ? urlFor(item.photo).width(400).format('webp').url() : '/assets/placeholder.webp',
          motto: item.motto || "VIX1ION Jaya!",
          ig: item.instagram
        }));

        setStudents(formattedStudents);
        setIsLoading(false);
      } catch (error) {
        console.error("Gagal mengambil data dari Sanity:", error);
        setIsLoading(false);
      }
    };

    fetchContent();
  }, []);

  // 2. Logic Navbar Auto-Hide
  useEffect(() => {
    const navbar = document.querySelector('nav');
    if (!navbar) return;

    if (selectedStudent) {
      navbar.classList.add('nav-hidden');
    } else {
      navbar.classList.remove('nav-hidden');
    }
    
    return () => navbar.classList.remove('nav-hidden');
  }, [selectedStudent]);

  // Data Guru (Statis)
  const teacherData = [
    { name: "Ustadz Oktav", role: "Wali Kelas", img: "/assets/teacher1.webp" },
    { name: "Ustadz Andi", role: "Pendamping", img: "/assets/teacher2.webp" },
  ];

  if (isLoading) return <div className="loading-screen"><div className="loader-bar"><div className="loader-progress"></div></div></div>;

  return (
    <section id="structure" className="structure-section">
      <div className="container">
        <h2 className="section-title">Class Structure</h2>

        {/* --- GRID GURU --- */}
        <div className="teacher-grid">
          {teacherData.map((item, index) => (
            <motion.div 
              key={index}
              className="member-card teacher"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <div className="member-img" style={{ backgroundImage: `url(${item.img})` }}></div>
              <h3 className="member-name">{item.name}</h3>
              <p className="member-role">{item.role}</p>
            </motion.div>
          ))}
        </div>

        <div className="divider-container" style={{ margin: '60px 0', textAlign: 'center', position: 'relative' }}>
            <hr className="divider" style={{ border: '0', borderTop: '1px solid rgba(255,255,255,0.1)' }} />
            <span className="divider-text" style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', background: '#050a14', padding: '0 20px', color: '#8892b0', textTransform: 'uppercase', fontSize: '0.9rem', letterSpacing: '2px' }}>Members</span>
        </div>

        {/* --- GRID SISWA (DINAMIS DARI SANITY) --- */}
        <div className="student-grid">
          {students.map((item) => (
            <motion.div 
              key={item.id}
              className="member-card"
              onClick={() => setSelectedStudent(item)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
            >
              <div className="member-img" style={{ backgroundImage: `url(${item.img})` }}></div>
              <h4 className="member-name">{item.name}</h4>
              <p className="member-role">{item.role}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* --- MODAL BIODATA --- */}
      <AnimatePresence>
        {selectedStudent && (
          <motion.div 
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedStudent(null)}
          >
            <button className="close-btn" style={{ position: 'absolute', top: '20px', right: '20px', background: 'none', border: 'none', color: '#fff', fontSize: '2rem', cursor: 'pointer', zIndex: 10001 }} onClick={() => setSelectedStudent(null)}>&times;</button>

            <motion.div 
              className="modal-content"
              initial={{ scale: 0.8, y: 50, opacity: 0 }}
              animate={{ scale: 1, y: 0, opacity: 1 }}
              exit={{ scale: 0.8, y: 50, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <div className="modal-img" style={{ backgroundImage: `url(${selectedStudent.img})` }}></div>
                <h2 className="full-name">{selectedStudent.fullName}</h2>
                <span className="modal-badge">{selectedStudent.role}</span>
              </div>

              <div className="modal-body">
                <div className="bio-item">
                  <span className="label">Motto</span>
                  <p className="motto-text">"{selectedStudent.motto}"</p>
                </div>

                <div className="bio-item">
                  <span className="label">Instagram</span>
                  <a 
                    href={`https://instagram.com/${selectedStudent.ig}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="modal-ig-link"
                  >
                    <i className="fab fa-instagram"></i> @{selectedStudent.ig}
                  </a>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Structure;